import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        height: '330px',
        maxHeight: '330px',
        overflowY: 'auto',
        width: '75px'
    },
    item: {
        transition: 'all .3s',
        padding: '3px 6px 5px',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'gray',
            color: '#fff',
        },


    },
    title: {
        padding: '3px 6px 5px',
        textAlign: 'center',
        width: '100%'
    }
}